import { render, staticRenderFns } from "./ocupacao-abrigos.vue?vue&type=template&id=5876c44b&"
import script from "./ocupacao-abrigos.vue?vue&type=script&lang=js&"
export * from "./ocupacao-abrigos.vue?vue&type=script&lang=js&"
import style0 from "./ocupacao-abrigos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports